export default __webpack_public_path__ + "9e5378ac3733b0232c8a9f2f91500ecf.png";